import { component } from 'picoapp';

export default component(async (node) => {
  const list = node.querySelector('[data-flag-list]');

  const { stores } = window.theme;
  const otherStores = stores.filter((store) => store.shopifyUrl !== window.Shopify.shop);

  const initList = () => {
    const itemsMarkup = otherStores.map((store) => `<li>
        <a href="https://${store.prettyUrl}" aria-label="${store.name}">
          ${store.flagIcon}
        </a>
      </li>`).join('');

    list.innerHTML = itemsMarkup;
  };

  const init = () => {
    initList();
  };

  init();
});
